import axios from "axios"

const axiosClient = axios.create()

function install(Vue) {
  Vue.axios = axiosClient
  window.axios = axiosClient
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return axiosClient
      }
    },
    $axios: {
      get() {
        return axiosClient
      }
    }
  })
}

export { axiosClient }
export default install
